import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import compose from 'recompose/compose';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Grid} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CalendarTodayIcon from '@material-ui/icons/Today';
import { ModalHeader } from 'reactstrap';
import {Button, TextField, FormControl, InputLabel, Select, MenuItem} from '@material-ui/core'
import Autocomplete  from '@material-ui/lab/Autocomplete';
import { withStyles } from '@material-ui/core/styles';
import { addTime, getProjektTimeTypes,getProjects,getBoardsAutoComplete, getProjektPlannedTimePreset } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import {TimePicker,MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import IntlMessages from 'util/IntlMessages';
import moment from 'moment-timezone'

const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    inputRoot: {
        padding: '9px 12px',
        fontSize: 20
      },
      adornedStart: {
        padding: 0
      }
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function mapStateToProps({auth,accountsData,Projekt}) {
    const { authUser} = auth;
    const { KundSearch,Flags} = accountsData;
    const { TimeTypes, ProjectListAutoComplete, BoardListAutoComplete,PlannedTimeCalendarPreset } = Projekt;
    return {
        authUser,KundSearch,Flags,TimeTypes,ProjectListAutoComplete, BoardListAutoComplete, PlannedTimeCalendarPreset
    };
}

function mapDispatchToProps(dispatch) {
    
    return {
        addTime: (Afid, Userid ,ProjektId, hours, comment, Today, type, category, Page,Start,End, Filterstate,fhours, BoardId) => dispatch(addTime(Afid, Userid ,ProjektId, hours, comment, Today, type, category, Page,Start,End, Filterstate, fhours, BoardId)),
        getProjektTimeTypes: (Afid, Userid) => dispatch(getProjektTimeTypes(Afid, Userid)),
        getProjects: (Afid, Userid, Page, PageSize, Searchword, StatusFilter, Filterstate, AutoComplete) => dispatch(getProjects(Afid, Userid, Page, PageSize, Searchword, StatusFilter, Filterstate, AutoComplete)),
				getBoardsAutoComplete:(Afid, Userid, projekt, Offset, Limit, Tab, cb) => dispatch(getBoardsAutoComplete(Afid, Userid, projekt, Offset, Limit, Tab, cb)),
				getProjektPlannedTimePreset:(Afid, Userid, ProjectId, Start, End) => dispatch(getProjektPlannedTimePreset(Afid, Userid, ProjectId, Start, End)),
        dispatch

    };
}

class PopUpSkapaKund extends Component {
    state={
        open:false,
        timmar:0,
        ftimmar:null,
        errorTimmar:false,
        minuter:0,
        errorMinuter:false,
        errorMessage: <IntlMessages id="Incorrect.fields.error"/>,

        fromTime:new Date('2014-08-18T08:00:00'),
        toTime:new Date('2014-08-18T17:00:00'),
        deduction:60,
        timeError: false,
        comment: '',
        today: new Date(),
        type: '',
        category: '',
        isHours: false,
        Error: false,
        ProjectId: 0,
				KundNamn: null,
				Board: {},
        errorProjectId: false,
				CurrentSelectedPlannedPreset: "",
				dateSelectOpen: false,
    }

		handleSelectPlannedPreset = (t)=>{

			let newStateObj = {
				fromTime: moment(t.Start).toDate(),
				toTime: moment(t.End).toDate(),
			}
			this.state.today.setDate(moment(t.Start).toDate().getDate())
			if(t.BoardId){
				newStateObj = {...newStateObj, Board: {id: t.BoardId}}
			} 
			if(t.TimeTypeObj){
				let thisType = this.props.TimeTypes.find(tt => t.TimeTypeObj.TypeName === tt.TypeName)

				if(thisType) {
					newStateObj = {
						...newStateObj,
						type: thisType
					}
				} 
			} 
			if(t.TimeCategory){
				newStateObj = {
					...newStateObj,
					category: t.TimeCategory
				}
			} 
			this.setState(state => ({...state, ...newStateObj, CurrentSelectedPlannedPreset: t}))
		}
		handleGetProjektPlannedTimePreset = (fromTime, toTime, ProjectId)=>{
			this.setState(state => ({...state, CurrentSelectedPlannedPreset: ""}))
			const Start = moment(`${moment(this.state.today).format('YYYY-MM-DD')} ${moment(fromTime).format('HH:mm')}`).add(-2, 'days')
			const End = moment(`${moment(this.state.today).format('YYYY-MM-DD')} ${moment(toTime).format('HH:mm')}`).add(2, 'days')
			const userid = this.props.authUser.user_id;
			const Kontoid = this.props.authUser.user_Afid;
			this.props.getProjektPlannedTimePreset(Kontoid,userid, ProjectId, Start.toDate(), End.toDate())
		}
    componentDidMount=()=>{
        
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        this.props.getProjektTimeTypes(Kontoid, userid)
        this.props.getProjects(Kontoid, userid, 0, 100000, "", 1, [], 1)
        this.setState({
            open:isUndefined(this.props.open)?false:this.props.open,
        })
    }
    componentDidUpdate=()=>{
        if(this.state.open !== this.props.open){

						let plannedEventProps 
						if(this.props.plannedEvent){

							let hours = moment(this.props.plannedEvent.End).diff(this.props.plannedEvent.Start, 'hours',true)
							hours = Math.round((hours - (this.state.deduction / 60)) *100) / 100

							let type = this.props.TimeTypes.find(tt => tt.id === this.props.plannedEvent.TimeTypeId)
							// let category = !type ? '' : type.Categories.find(cc => cc.id)
							let category = this.props.plannedEvent.TimeCategory

							const userid = this.props.authUser.user_id;
							const Kontoid = this.props.authUser.user_Afid;
							console.log(this.props.plannedEvent.ProjectId, this.props.plannedEvent, 'ppppppppppppppppppp')
							this.props.getBoardsAutoComplete(Kontoid,userid,{id: this.props.plannedEvent.ProjectId}, undefined, undefined, undefined, ()=>{
								this.setState({Board: {id: this.props.plannedEvent.BoardId}})
							})
							this.handleGetProjektPlannedTimePreset(new Date(this.props.plannedEvent.Start), new Date(this.props.plannedEvent.End), this.props.plannedEvent.ProjectId)

							plannedEventProps=  {
								timmar:hours,
								ftimmar:hours,
								minuter:0,

								fromTime:new Date(this.props.plannedEvent.Start),
								toTime:new Date(this.props.plannedEvent.End),
								today: new Date(this.props.plannedEvent.Start),
								type: type??'',
								category: category??'',
								ProjectId: this.props.plannedEvent.ProjectId,
								CurrentSelectedPlannedPreset: this.props.plannedEvent,
							}
						}
            this.setState({
                open:this.props.open,
								...plannedEventProps
            })
        }
    }
    handleClose = () => {
        this.setState({
            open:false,
            timmar:0,
            ftimmar:null,
            errorTimmar:false,
            minuter:0,
            errorMinuter:false,
            errorMessage: <IntlMessages id="Incorrect.fields.error"/>,
    
            fromTime:new Date('2014-08-18T08:00:00'),
            toTime:new Date('2014-08-18T17:00:00'),
            deduction:60,
            timeError: false,
            comment: '',
            today: new Date(),
            type: '',
            category: '',
            isHours: false,
            Error: false,
						ProjectId: 0,
						KundNamn: null,
						Board: {},
						errorProjectId: false,
						CurrentSelectedPlannedPreset: "",
						dateSelectOpen: false,
        })
        this.props.handleClose(false)
    }
    handleComplete = () => {
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        if(this.state.isHours){
            if((this.state.timmar === 0 && this.state.minuter === 0) || this.state.ProjectId === 0){
            this.setState({...this.state, 
                errorTimmar: this.state.timmar === 0 && this.state.minuter === 0,
                errorMinuter: this.state.timmar === 0 && this.state.minuter === 0,
                Error: true,
                errorProjectId: this.state.ProjectId === 0
            })
            } else {
              let hours = this.state.timmar + (this.state.minuter/60)
              let fhours = parseFloat(String(this.state.ftimmar ?? this.returnCalcFtimmar()).replace(/,/g, '.')) 
              // let Start = d+" "+t
              let Start = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD') + ' ' + moment(this.state.fromTime).tz("Europe/Stockholm").format('HH:mm')
              let End = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD') + ' ' + moment(this.state.toTime).tz("Europe/Stockholm").format('HH:mm')
              let Today = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD HH:mm')
              
              this.props.addTime(Kontoid, userid,this.state.ProjectId, hours, this.state.comment, Today, this.state.type, this.state.category, 0, moment(Start), moment(End), [], fhours, this.state.Board.id)
              this.handleClose()
            }
          }
          else {
            // let timeStart = new Date("01/01/2000 " + fromTime).getHours() + ((new Date("01/01/2000 " + fromTime).getMinutes()) / 60);
            // let timeEnd = new Date("01/01/2000 " + toTime).getHours() + ((new Date("01/01/2000 " + toTime).getMinutes()) / 60);
            let hours = moment(this.state.toTime).diff(this.state.fromTime, 'hours', true)
            hours = Math.round((hours - (this.state.deduction / 60)) *100) / 100
            let fhours = parseFloat(String(this.state.ftimmar ?? this.returnCalcFtimmar()).replace(/,/g, '.')) 
            if(hours < 0 || this.state.ProjectId === 0) {
                this.setState({...this.state, timeError: hours < 0, errorProjectId: this.state.ProjectId === 0, Error: true, })
            } else {
              let Start = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD') + ' ' + moment(this.state.fromTime).tz("Europe/Stockholm").format('HH:mm')
              let End = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD') + ' ' + moment(this.state.toTime).tz("Europe/Stockholm").format('HH:mm')
              let Today = moment(this.state.today).tz("Europe/Stockholm").format('YYYY-MM-DD HH:mm')
              this.props.addTime(Kontoid, userid,this.state.ProjectId, hours, this.state.comment, Today, this.state.type, this.state.category, 0, moment(Start), moment(End), [], fhours, this.state.Board.id)
              this.handleClose()
            }
          }
    }
    formatDate = (date) => {
        let day = date.getDay()
        let formattedDay = ""
        switch(day) {
          case 0:
            formattedDay =<IntlMessages id="Label.Sunday"/>
            break
          case 1:
            formattedDay =<IntlMessages id="Label.Monday"/>
            break
          case 2:
            formattedDay =<IntlMessages id="Label.Tuesday"/>
            break
          case 3:
            formattedDay =<IntlMessages id="Label.Wednesday"/>
            break
          case 4:
            formattedDay =<IntlMessages id="Label.Thursday"/>
            break
          case 5:
            formattedDay =<IntlMessages id="Label.friday"/>
            break
          case 6:
            formattedDay =<IntlMessages id="Label.Saturday"/>
            break
          default:
            formattedDay =<IntlMessages id="Label.Monday"/>
            break
        }
        return <h3 className="m-0 text-dark"><span className=" font-weight-bold">{formattedDay}</span> {date.getDate() + "/" + (date.getMonth() + 1)}</h3>
      }
      addDays = (days) => {
        this.setState({...this.state, today: new Date(moment(this.state.today, 'YYYY-MM-DD HH:mm').add('days', days))})
      }
      handleChangeState = (key, value) => {
        let ftimmar = this.state.ftimmar
        if(key === "fromTime" || key=== "toTime") {
          let hours = moment(key === "toTime" ? value :this.state.toTime).diff(key === "fromTime" ? value : this.state.fromTime, 'hours', true)
          hours = Math.round((hours - (this.state.deduction / 60)) *100) / 100
          ftimmar=hours
        }
        this.setState({
            ...this.state,
            // ftimmar: ftimmar,
            [key]: value
        })
      }

		returnCalcFtimmar = () => {
			let hours = moment(this.state.toTime).diff(this.state.fromTime, 'hours',true)
			hours = Math.round((hours - (this.state.deduction / 60)) *100) / 100
			return hours
		}
    render() {
        const { fullScreen, classes } = this.props;
        
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title"
            fullScreen={fullScreen}
            fullWidth={true}
            open={isUndefined(this.state.open)?false:this.state.open} 
            maxWidth={"xs"} 
            disableBackdropClick={true} 
            >
        <ModalHeader className="modal-box-header bg-primary text-white">
            <IntlMessages id="Header.Report.time"/>
            <IconButton className="text-white"
                onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers>
            <div className="d-flex align-items-center justify-content-between w-100 mb-3">
            <IconButton onClick={() => {
								this.addDays(-1)
								this.handleGetProjektPlannedTimePreset(this.state.fromTime, this.state.toTime, this.state.ProjectId)
							}}>
              <ArrowBackIosIcon/>
            </IconButton>

						<div className='d-flex align-items-center' style={{gap: 5}}>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<IconButton onClick={() => this.setState(s=>({...s, dateSelectOpen: true}))} size="small" color="primary">
									<CalendarTodayIcon/>
								</IconButton>
								<DatePicker
									open={this.state.dateSelectOpen}
									onClose={() => this.setState(s=>({...s, dateSelectOpen: false}))}
									value={this.state.today}
									onChange={(d) => this.setState(s=>({...s, today: d}))}
									TextFieldComponent={() => null} // Hide the default input
								/>
							</MuiPickersUtilsProvider>
              {this.formatDate(this.state.today)}
						</div>
            <IconButton onClick={() => {
							this.addDays(1)
							this.handleGetProjektPlannedTimePreset(this.state.fromTime, this.state.toTime, this.state.ProjectId)
						}}>
              <ArrowForwardIosIcon/>
            </IconButton>
          </div>

          <Grid container spacing={2} >
              
            <Grid item xs="12">
            <Autocomplete
                //  value={this.state.Value}
								value={{id: this.state.ProjectId}}	
								getOptionSelected={(o, value)=>{
									if(value.id === o.id) console.log(o,value.id === o.id,'kkkkk')
									return value.id === o.id
								}}
								getOptionLabel={(option) => {
										let selectedOption = this.props.ProjectListAutoComplete.find(b => b.id === option.id)
										if(selectedOption) return selectedOption.ProjectName
										return option.ProjectName;
									}}
                disableClearable
                 onChange={(event, newValue) => {
										const userid = this.props.authUser.user_id;
										const Kontoid = this.props.authUser.user_Afid;
										this.setState({
											ProjectId: newValue.id,
											KundNamn: newValue.KundNamn
										})
										this.props.getBoardsAutoComplete(Kontoid,userid,newValue)
										this.handleGetProjektPlannedTimePreset(this.state.fromTime, this.state.toTime, newValue.id)
                  }}
                 id="combo-box-demo"
                 options={isUndefined(this.props.ProjectListAutoComplete)?[]:this.props.ProjectListAutoComplete.sort((a,b)=> a.ProjectName.trim().toUpperCase() > b.ProjectName.trim().toUpperCase() )}
                 // getOptionLabel={(option) => {
                 //    return option.ProjectName;
                 //  }}
                  selectOnFocus
                  renderInput={(params) => (
                      <TextField {...params} error={this.state.errorProjectId} label={<IntlMessages id="Input.Choose.project" />} variant="outlined" size="small" />
                      )}
                />
            </Grid>
						{
							this.state.KundNamn && 
							<Grid item xs={12}>
								<TextField
									value={this.state.KundNamn}
									label={<IntlMessages id="Table.Customer"/>}
									size="small"
									variant='outlined'
									disabled
									fullWidth
								/>
							</Grid>
						}
						<Grid item xs ={12}>
							<FormControl className={classes.formControl} fullWidth variant="outlined" size="small">
								<InputLabel id="PlannedPreset"><IntlMessages id={"Project.Planning"} /></InputLabel>
								<Select
								// inputProps={{
								//   className: classes.inputRoot,
								// }}
									label={<IntlMessages id="Project.Planning"/>}
									labelId="PlannedPreset"
									id="PlannedPreset"
									value={this.props.PlannedTimeCalendarPreset.find(t => t.id === this.state.CurrentSelectedPlannedPreset?.id) ?? ''}
									onChange={(e) => this.handleSelectPlannedPreset(e.target.value)}
								>
									<MenuItem value={""}>
										<em><IntlMessages id={"None2"} /></em>
									</MenuItem>
									{
										this.props.PlannedTimeCalendarPreset.map(t => {
											let typ = ''
											if(!isEmpty(t.TimeTypeObj)){
												typ = `(${t.TimeTypeObj.TypeName})`
											}
											return (
												<MenuItem value={t}>
													{`${moment(t.Start).format('ddd DD/MM')} ${moment(t.Start).format('HH:mm')} - ${moment(t.End).format('HH:mm')} ${typ}`}
												</MenuItem>
											)
										})
									}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs="12">
							<Autocomplete
									//  value={this.state.Value}
									disableClearable
									value={this.state.Board}	
									onChange={(event, newValue) => {
                    	this.handleChangeState('Board', {id:newValue.id})
											// this.handleChangeState('ProjectId', newValue.id)
										}}
									getOptionSelected={(o, value)=>{
										console.log(o,value === o.id,'kkkkk')
										return value.id === o.id
									}}
									id="combo-box-demo"
									options={this.props.BoardListAutoComplete.sort((a,b)=> a.BoardName.trim().toUpperCase() > b.BoardName.trim().toUpperCase() )}
									getOptionLabel={(option) => {
											let selectedOption = this.props.BoardListAutoComplete.find(b => b.id === option.id)
											if(selectedOption) return selectedOption.BoardName
											return option.BoardName;
										}}
										selectOnFocus
										renderInput={(params) => (
											<TextField {...params}  label={<IntlMessages id="Label.Choose.project.part"/>} variant="outlined" size="small" />
										)}
									/>
						</Grid>
          {/* <Grid item xs="12">
          <FormControlLabel
            control={<Checkbox checked={isHours} onChange={(e) => setIsHours(e.target.checked)} name="checkedA" color="primary"/>}
            label="Ange i antal timmar och minuter"
          />
          </Grid> */}
         
         {
           this.state.isHours ? 
           <>
           <Grid item xs="6">
            <TextField 
            inputProps={{
              // className: classes.inputRoot,
            }}
            defaultValue={0}
            fullWidth
            onChange={e=>this.handleChangeState('timmar', e.target.value)}
            value={this.state.timmar}
            error={this.state.errorTimmar}
            label={<IntlMessages id="Times"/>}
            variant="outlined" size="small" type="number" 
              />
            </Grid>
            <Grid item xs="6">
            <TextField 
            inputProps={{
              // className: classes.inputRoot,
              // min: 0, max: 59
            }}
            error={this.state.errorMinuter}
            defaultValue={0}
            fullWidth
            onChange={e=>this.handleChangeState('minuter', e.target.value)}
            value={this.state.minuter}
            label={<IntlMessages id="Minutes"/>}
            variant="outlined" size="small" type="number" 
              />
            </Grid>
           </>
           :
           <>
             <Grid item xs="4">
             <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
              <TimePicker 
              // inputProps={{
              //   className: classes.inputRoot,
              // }}
              clearable
              value={this.state.fromTime}
              onChange={e=>{
								this.handleChangeState('fromTime',e)
								this.handleGetProjektPlannedTimePreset(e, this.state.toTime, this.state.ProjectId)
							}}
              fullWidth
              error={this.state.timeError}
              label={<IntlMessages id="From"/>}
              ampm={false}
              inputVariant="outlined"
              size="small"
                />
              </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs="4">
              <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
              <TimePicker 
              // inputProps={{
              //   className: classes.inputRoot,
              // }}
                clearable
                value={this.state.toTime}
                error={this.state.timeError}
                onChange={e=>{
									this.handleChangeState('toTime',e)
									this.handleGetProjektPlannedTimePreset(this.state.fromTime, e, this.state.ProjectId)
								}}
                fullWidth
                label={<IntlMessages id="To"/>}
                ampm={false}
                  inputVariant="outlined"
                  size="small"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs="4">
            <FormControl className={classes.formControl} fullWidth variant="outlined" size="small">
              <InputLabel id="demo-simple-select-label"><IntlMessages id="Label.Break.deduction"/></InputLabel>
              <Select
              // inputProps={{
              //   className: classes.inputRoot,
              // }}
                label={<IntlMessages id="Label.Break.deduction"/>}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                error={this.state.timeError}
                value={this.state.deduction}
                onChange={e=>this.handleChangeState('deduction',e.target.value)}
              >
                <MenuItem value={0}>
                  <em><IntlMessages id={"None2"} /></em>
                </MenuItem>
                <MenuItem value={10}>10 <IntlMessages id="Minutes.short"/></MenuItem>
                <MenuItem value={15}>15 <IntlMessages id="Minutes.short"/></MenuItem>
                <MenuItem value={30}>30 <IntlMessages id="Minutes.short"/></MenuItem>
                <MenuItem value={60}>60 <IntlMessages id="Minutes.short"/></MenuItem>
              </Select>
            </FormControl>
            </Grid>
           </>
         }
         

            <Grid item xs ="6">
            <FormControl className={classes.formControl} fullWidth variant="outlined" size="small">
              <InputLabel id="Typ"><IntlMessages id={"Input.Type"} /></InputLabel>
              <Select
              // inputProps={{
              //   className: classes.inputRoot,
              // }}
                label={<IntlMessages id="Input.Type"/>}
                labelId="Typ"
                id="Typ"
                value={this.state.type}
                onChange={e=>this.handleChangeState('type',e.target.value)}
              >
                <MenuItem value={""}>
                  <em><IntlMessages id={"None2"} /></em>
                </MenuItem>
                {
                  isEmpty(this.props.TimeTypes.filter(t => t.hidden === 0)) ? "" : 
                  this.props.TimeTypes.filter(t => t.hidden === 0).map((_type,index) => {
                    return (
                      <MenuItem key={index} value={_type}>{_type.TypeName}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Grid>
            <Grid item xs ="6">
              <FormControl className={classes.formControl} fullWidth variant="outlined" size="small">
                <InputLabel id="Kategori"><IntlMessages id="Category.label"/></InputLabel>
                <Select
                // inputProps={{
                //   className: classes.inputRoot,
                // }}
                  label={<IntlMessages id="Category.label"/>}
                  labelId="Kategori"
                  id="Kategori"
                  value={this.state.category}
                  onChange={e=>this.handleChangeState('category',e.target.value)}
                >
                  <MenuItem value={""}>
                    <em><IntlMessages id={"None2"} /></em>
                  </MenuItem>
                  {
                    isEmpty(this.state.type.Categories) || isUndefined(this.state.type.TypeName) ? "" : 
                    this.state.type.Categories.map((_category,index) => {
                      return (
                        <MenuItem key={index} value={_category}>{_category.CategoryName}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs ={6}>
            <TextField 
                disabled
                inputProps={{
                  // className: classes.inputRoot,
                  // min: 0, max: 59
                }}
                fullWidth
                error={moment(this.state.toTime).diff(this.state.fromTime, 'hours',true) - (this.state.deduction / 60) < 0}
                value={Math.round((moment(this.state.toTime).diff(this.state.fromTime, 'hours',true) - (this.state.deduction / 60)) * 100) / 100}
                label={<IntlMessages id="Label.Working.hours"/>}
                variant="outlined" 
                size="small" 
              />
            </Grid>
            <Grid item xs ={6}>
              <TextField 
                inputProps={{
                  // className: classes.inputRoot,
                  // min: 0, max: 59
                }}
                onChange={(e) => {
                  var regex = /^[0-9.,\b]+$/; 
                  if(regex.test(e.target.value)) this.setState({ftimmar:e.target.value})
                  if(e.target.value === "") this.setState({ftimmar:e.target.value})
                }}
                value={this.state.ftimmar ?? this.returnCalcFtimmar()}
                fullWidth
                label={<IntlMessages id="Label.Ivoicable.hours"/>}
                variant="outlined" 
                size="small" 
              />
            </Grid>
            <Grid item xs="12">
            <TextField 
            fullWidth
            multiline
            rows={5}
            rowsMax={5}
            value={this.state.comment}
            onChange={e=>this.handleChangeState('comment',e.target.value)}v
            label={<IntlMessages id="Label.Comment.Intern"/>}
            variant="outlined" size="small" type="number" 
              />
            </Grid>
            
          </Grid>

        </DialogContent>
        <DialogActions>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                <div>
                    <Button onClick={this.handleClose} variant="outlined" color="default" 
                    className="jr-btn">
                        <IntlMessages id="Cancel"/>
                    </Button>
                </div>
                <div className="ml-auto">
                  <Button
                    color="primary"
                    className="jr-btn"
                    variant="contained"
                    // disabled={
                    //     isEmpty(this.state.newKund.Orgnr) ||
                    //     this.state.newKund.Orgnr.length <8 ||
                    //     isEmpty(this.state.newKund.KundNamn)
                    // }
                    onClick={this.handleComplete}
                    >
                    <IntlMessages id="Label.Register"/>
                    </Button>
                    </div>
                    </Grid>
        </DialogActions>
    </Dialog> 
        );
    }
}

export default compose(
    withStyles(styles),
    (withMediaQuery([
        ['fullScreen', theme => theme.breakpoints.down('xs'), {
          defaultMatches: true
        }]
      ])),
    connect(mapStateToProps,mapDispatchToProps)
)(PopUpSkapaKund);



